import { getStreamProgressStatus, useContentProgress } from 'ContentProgress';
import { usePlaylist } from 'Playlists';
import { useRequiredCurrentUser } from 'FrontRoyalAngular';
import { type Stream } from 'Lessons';
import { useStreams } from 'Streams';
import { useMemo, useCallback } from 'react';
import { getActivePlaylistLocalePackId } from 'Users';

export function useGetActivePlaylistStreams() {
    const currentUser = useRequiredCurrentUser();
    const { streamProgress } = useContentProgress();
    const activePlaylistLocalePackId = getActivePlaylistLocalePackId(currentUser);
    const activePlaylist = usePlaylist(activePlaylistLocalePackId ?? '');

    const activePlaylistStreamLocalePackIds = useMemo(
        () => activePlaylist?.streamEntries.map(entry => entry.localePackId) ?? [],
        [activePlaylist],
    );
    const activePlaylistStreams = useStreams(activePlaylistStreamLocalePackIds);

    const getProgressInfo = useCallback(
        (stream: Stream) => {
            const progress = streamProgress.find(sp => sp.localePackId === stream.localePack.id);

            return {
                status: getStreamProgressStatus(progress),
            };
        },
        [streamProgress],
    );

    const numCourses = activePlaylistStreams.filter(stream => stream.exam === false).length;
    const numExams = activePlaylistStreams.filter(stream => stream.exam === true).length;
    const numComplete = activePlaylistStreams.filter(stream => getProgressInfo(stream)?.status === 'completed').length;
    const numProjects = 0; // TODO: implement grabbing projects from the cohort's periods array and linking them to the active playlist https://trello.com/c/htdVv9ME

    return {
        activePlaylistStreams,
        activePlaylist,
        numCourses,
        numExams,
        numComplete,
        numProjects,
        getProgressInfo,
    };
}
